import React from 'react';

const MyHistory = () => {
    return (
        <div>
            <h3>My history</h3>
        </div>
    );
};

export default MyHistory;